export default __webpack_public_path__ + "static/media/affiliateRegLogin.2dbaf5ee.webp";